import client from "@/apis/client";
import { type ClassroomScreenPageInput } from "@/services/fobizzToolsApi";

export async function createPage(
  screenId: string,
  attrs: Partial<ClassroomScreenPageInput>
) {
  const body = {
    page: attrs,
  };
  const response = await client.post(
    `/api/teaching_board/screens/${screenId}/pages`,
    body
  );
  return response.data;
}

export async function update(
  id: string,
  attrs: Partial<ClassroomScreenPageInput>
) {
  const body = {
    page: attrs,
  };

  const response = await client.patch(`/api/teaching_board/pages/${id}`, body);
  return response.data;
}

export async function movePage(
  id: string,
  attrs: Partial<ClassroomScreenPageInput>
) {
  const body = {
    page: attrs,
  };
  const response = await client.patch(
    `/api/teaching_board/pages/${id}/move`,
    body
  );
  return response.data;
}

export async function deletePage(id: string) {
  const response = await client.delete(`/api/teaching_board/pages/${id}`);
  return response.data;
}
